import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteTransition',
  props: {
    routeTransition: {}
  },
  setup(__props: any) {



// Disable route transitions on E2E to avoid flakiness.
const isE2E = !!window.navigator?.webdriver;

return (_ctx: any,_cache: any) => {
  return (!isE2E)
    ? (_openBlock(), _createBlock(_Transition, {
        key: 0,
        name: __props.routeTransition,
        css: true
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["name"]))
    : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
}
}

})